import React, { forwardRef } from 'react'
import Link, { LinkProps } from 'next/link'

type LinkPropsWithoutPrefetch = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  Omit<LinkProps, 'prefetch'> & {
    children: React.ReactNode
  } & React.RefAttributes<HTMLAnchorElement>

const LinkWithoutPrefetch = forwardRef<
  HTMLAnchorElement,
  LinkPropsWithoutPrefetch
>(({ children, ...props }, ref) => {
  return (
    <Link prefetch={false} {...props} ref={ref}>
      {children}
    </Link>
  )
})

LinkWithoutPrefetch.displayName = 'Shared.LinkWithoutPrefetch'

export default LinkWithoutPrefetch
